import { AssetBlok, sizes } from "@/components/bloks/Asset";
import { Skeleton } from "@/components/ui/Skeleton";
import type { StoryblokMultiasset } from "@/storyblok";
import styles from "./Hero4.module.css";

export interface Hero4Props {
	heading: string;
	preamble?: string;
	tag?: string;
	image?: StoryblokMultiasset;
	breadcrumbs?: React.ReactNode;
}

export const Hero4 = ({
	tag,
	heading,
	preamble,
	image,
	breadcrumbs,
	...rest
}: Hero4Props) => {
	return (
		<section
			{...rest}
			className={styles.root}
			data-has-breadcrumbs={!!breadcrumbs}
		>
			{breadcrumbs && <div className={styles.breadcrumbs}>{breadcrumbs}</div>}
			<div className={styles.content}>
				<div className={styles.image}>
					{image && <AssetBlok priority sizes={sizes(90, 50)} source={image} />}
				</div>
				<div className={styles.intro}>
					<span className={styles.tag}>{tag}</span>
					<h1 className={styles.heading}>{heading}</h1>
				</div>
				<div className={styles.preamble}>{preamble}</div>
			</div>
		</section>
	);
};

export const Hero4Skeleton = () => {
	return (
		<section className={styles.root}>
			<div className={styles.content}>
				<Skeleton className={styles.image} />
				<div className={styles.intro}>
					<Skeleton fitContent>
						<span className={styles.tag}>Lorem</span>
					</Skeleton>
					<Skeleton fitContent>
						<h2 className={styles.heading}>Lorem ipsum dolor sit amet.</h2>
					</Skeleton>
				</div>
				<Skeleton className={styles.preamble}>
					Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aperiam
					explicabo voluptates commodi, vero officia adipisci debitis mollitia?
					Ea, accusamus explicabo!
				</Skeleton>
			</div>
		</section>
	);
};
